import { Controller } from 'stimulus'
import Google from 'mixins/google'

export default class extends Google(Controller) {

  static targets = ['dropdown']

  connect() {
    this.message = this.element.dataset.turboConfirm
    this.element.removeAttribute('data-turbo-confirm')
  }

  change() {
    if (this.dropdownTarget.value == 'closed' && this.message) {
      this.element.dataset.turboConfirm = this.message
    } else {
      this.element.removeAttribute('data-turbo-confirm')
    }
  }
}
